import axios from '@_system/axios/axios.js'
export default {
	path: '/report',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	reportconfig(name, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/reportconfig/' + name, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	reportlist(name, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/reportlist/' + name, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	reportexport(name, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reportexport/' + name, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getSingleReportControll(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getSingleReportControll/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},	
	
	
	
}
